import { render, staticRenderFns } from "./MenuColumn.vue?vue&type=template&id=112a76be&"
import script from "./MenuColumn.vue?vue&type=script&lang=js&"
export * from "./MenuColumn.vue?vue&type=script&lang=js&"
import style0 from "./MenuColumn.vue?vue&type=style&index=0&id=112a76be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports